import React, { useState, useEffect } from 'react';
import './Contact.css';
import useScrollReveal from '../hooks/useScrollReveal';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    wantsBeratung: false,
    marketingConsent: false
  });

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    error: null
  });

  // Auto-check "Erstberatung" if user clicked a Beratungsgespräch button
  useEffect(() => {
    if (sessionStorage.getItem('autoBeratung') === 'true') {
      setFormData(prev => ({ ...prev, wantsBeratung: true }));
      sessionStorage.removeItem('autoBeratung');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitted: false, submitting: true, error: null });

    try {
      const response = await fetch('https://formspree.io/f/xpqpkqrv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          company: formData.company,
          email: formData.email,
          wantsBeratung: formData.wantsBeratung,
          marketingConsent: formData.marketingConsent
        })
      });

      if (response.ok) {
        setStatus({ submitted: true, submitting: false, error: null });
        setFormData({
          name: '',
          company: '',
          email: '',
          wantsBeratung: false,
          marketingConsent: false
        });
      } else {
        throw new Error('Formular konnte nicht gesendet werden');
      }
    } catch (error) {
      setStatus({ submitted: false, submitting: false, error: error.message });
    }
  };

  const headerRef = useScrollReveal();
  const formRef = useScrollReveal();

  return (
    <section id="contact" className="contact">
      <div className="section-container">
        <div ref={headerRef} className="contact-header reveal">
          <p className="contact-cta">
           Nutzen Sie jetzt Ihr volles Potenzial durch den kostenlosen Ratgeber und ein kostenloses Beratungsgespräch.


          </p>
          <p className="contact-email">
            E-Mail-Adresse: <a href="mailto:info@ff-ai-automation.de">info@ff-ai-automation.de</a>
          </p>
        </div>

        <div ref={formRef} className="contact-form-wrapper reveal">
          {status.submitted ? (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <h3>Vielen Dank!</h3>
              <p>Wir senden Ihnen den Ratgeber in Kürze zu.</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name <span className="required-star">*</span></label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">Unternehmen</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">E-Mail-Adresse <span className="required-star">*</span></label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <label className="form-checkbox">
                <input
                  type="checkbox"
                  name="wantsBeratung"
                  checked={formData.wantsBeratung}
                  onChange={handleChange}
                />
                <span>Ich möchte eine kostenlose Erstberatung</span>
              </label>

              <label className="form-checkbox">
                <input
                  type="checkbox"
                  name="marketingConsent"
                  checked={formData.marketingConsent}
                  onChange={handleChange}
                  required
                />
                <span>Meine Daten dürfen für Marketingzwecke verwendet werden <span className="required-star">*</span></span>
              </label>

              {status.error && (
                <div className="error-message">
                  {status.error}
                </div>
              )}

              <button
                type="submit"
                className="btn btn-primary btn-full"
                disabled={status.submitting}
              >
                {status.submitting ? 'Wird gesendet...' : 'Jetzt Ratgeber anfordern'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

export default Contact;
